import type {Listing} from "@hosttools/frontend/models/listing";
import type {CellContext} from "@tanstack/react-table";
import type React from "react";
import {memo} from "react";

import ListingImages from "./ListingImages";

const ListingImagesCell: React.FC<CellContext<Listing, string>> = ({row: {original: listing}}) => {
    return <ListingImages listing={listing} />;
};

export default memo(ListingImagesCell);
